<template>
	<div class="app-menu">
<!--		<appLogo></appLogo>-->
		<div class="h-menu h-menu-dark" :class="sliderCollapsed?'h-menu-mode-collapse':'h-menu-mode-vertical'">
			<li class="h-menu-li h-menu-first-level" v-for="m in menus" @click="trigger(m)">
				<Tooltip v-if="sliderCollapsed&& m.children &&!m.children.length" :content="m.title" placement="right">
					<div class="h-menu-show" :class="{' h-menu-li-selected':selected(m)}">
						<span class="h-menu-show-icon" v-if="m.icon">
							<i :class="m.icon"></i>
						</span>
						<span class="h-menu-show-desc text-13px">{{ m.title }}</span>
						<span class="h-menu-show-expand" v-if="m.children"><i class="h-icon-angle-down"></i></span>
					</div>
				</Tooltip>
				<template v-else>
					<div class="h-menu-show" :class="{' h-menu-li-selected':selected(m)}" style="line-height: 18px">
						<span class="h-menu-show-icon" v-if="m.icon">
							<img class="h-menu-show-image" v-if="selected(m)" :src="bindIcon(m.icons)" />
							<img class="h-menu-show-image" v-else :src="bindIcon(m.icon)" />
						</span>
						<span class="h-menu-show-desc text-13px">{{ m.title }}</span>
						<span class="h-menu-show-expand" v-if="m.children"><i class="h-icon-angle-down"></i></span>
					</div>
				</template>
				<div class=" h-menu-other-levels !flex" :class="{'flex-column':m.children.filter(val=>val.children).length===0}" v-if="m.children && m.children.length">
					<template v-for="c1 in m.children">
						<template v-if="c1.children && c1.children.length">
							<div class="flex-1 m-8px">
								<div class="py-8px px-4px primary-color font-bold text-13px"> {{ c1.title }}</div>
								<div @click.stop="trigger(c2)" class="p-6px text-hover text-13px" :class="currentTab === c2.key?'font-bold primary-color':''" v-for="c2 in c1.children" :key="c2.key">
									{{ c2.title }}
								</div>
							</div>
						</template>
						<div v-else :class="currentTab === c1.key?'font-bold primary-color':''" class="py-8px px-16px text-hover text-13px" @click.stop="trigger(c1)">
							{{ c1.title }}
						</div>
					</template>
				</div>
			</li>
		</div>
		<div class="version">
<!--			<div>v{{ VERSION }}</div>-->
			 <div @click.stop="trigger({title:'更新日志', key:'ChangeLog'})">v{{ VERSION + '.'+ dFormat(BUID_DATE, 'YYYYMMDD') }}</div>
		</div>
	</div>
</template>
<script>
	import {mapMutations, mapState} from 'vuex';
	import appLogo from './app-logo';
	import $ from 'jquery';
	import report from "../../api/report";

	export default {
		name: "AppMenu",
		props: {
			theme: String
		},
		computed: {
			...mapState(['User', 'sliderCollapsed', 'currentAccountSets', 'currentTab', 'menus'])
		},
		methods: {
			...mapMutations(['newTab']),
			selected(item) {
				if (this.menus) {
					let find = this.menus.find(val => {
						if (val.key === this.currentTab) {
							return true;
						} else if (val.children) {
							for (const c1 of val.children) {
								if (c1.key === this.currentTab) {
									return true;
								} else if (c1.children) {
									for (const c2 of c1.children) {
										if (c2.key === this.currentTab) {
											return true;
										}
									}
								}
							}
						}
					})
					return find && (item.key === find.key);
				}
				return false;
			},
			trigger(data) {
				if (!data.children) {
					if (data.key === 'Home' && this.currentTab !== data.key) {
						this.$store.commit('refreshHomeTab', {key: "Home", title: "首页"})
					} else this.newTab(data);
				}
			},
			hideMenu() {
				this.$store.commit('updateSliderCollapse', true);
			},
			bindIcon(icon) {
				return require("@/assets/menu/" + icon + ".png");
			}
		},
		components: {
			appLogo
		},
		created() {
			if (this.menus) {
				report.template.select().then(({data}) => {
					const reportList = this.menus.find(val => val.key === "ReportList")
					if (reportList) {
						data.forEach(item => {
							item.dimensions.forEach(d => {
								if (reportList.children) {
									reportList.children.push({
										title: item.name + (d === 'QUARTER' ? "季报" : ''),
										key: "ReportView:" + item.templateKey + (d === 'QUARTER' ? ":" + d : ''),
										params: {
											reportId: item.templateKey,
											dimension: d
										}
									})
								}
							})
						})
					}
				});
			}
		},
		mounted() {
			$('.h-menu .h-menu-first-level').hover((e) => {
				const maxHeight = window.document.body.scrollHeight;
				const other = $('.h-menu-other-levels', e.currentTarget);
				if (other.length) {
					const offset = $(e.currentTarget).offset()
					const height = other.height()
					if (offset.top + height > maxHeight) {
						other.offset({
							top: maxHeight - height - 30
						})
					} else {
						other.offset({
							top: offset.top
						})
					}
				}
			})
		}
	};
</script>
<style lang="less" scoped>
	.version {
		position: absolute;
		font-weight: bold;
		bottom: 0;
		left: 0;
		width: 100%;
		color: white;
		text-align: center;
		z-index: -1;
		font-size: 12px;
		white-space: nowrap;
    overflllow:hidden;
	}

  .version:hover {
    color:#3b76f5;
    cursor: pointer;
  }

	.h-menu-mode-vertical {
		> .h-menu-li {
			> .h-menu-show {
				padding-left: 10px;
			}
		}

		.h-menu-li-selected{
			color: @white-color !important;
			background-color: #3b76f5;
		}

		.h-menu-show {
			overflow: hidden;
			text-overflow: ellipsis;
			color: #b3b3b3;
			padding: 15px 10px;
			transition: color @transition-time;

			&-icon {
				margin-right: 5px;
			}
			.h-menu-show-image {
				float: left;
				height: 18px;
			}

			&-expand {
				> i {
					transition: transform @transition-time;
					transform: rotate(-90deg);
				}
				right: 10px;
			}
		}

		.h-menu-other-levels {
			background-color: #FFFFFF !important;
			box-shadow: @box-shadow;
			color: #001529 !important;
			padding: 5px 0;
			margin-left: 4px;
			left: 100%;
			top: 0;
			border-radius: 10px;
			overflow: hidden;
			position: absolute;
			width: 0;
			transition: 0.2s cubic-bezier(0.78, 0.17, 0.43, 1);
			white-space: nowrap;
			display: inline-block;
			opacity: 0.8;
			transform: scale(0.8);
			transform-origin: left;
			max-height: initial !important;

			.h-menu-show {
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.h-menu-li:hover {
			> .h-menu-other-levels {
				width: auto;
				opacity: 1;
				transform: scale(1);
				overflow: visible;
				border: 3px solid #3b76f5;

				&:before {
					content: '';
					position: absolute;
					height: 100%;
					top: 0;
					left: -10px;
					width: 10px;
				}
			}
		}
	}

	.h-menu.h-menu-mode-collapse .h-menu-other-levels {
		width: 0 !important;
		max-width: none !important;
	}

	.h-menu.h-menu-mode-collapse {
		.h-menu-li:hover {
			.h-menu-other-levels {
				width: auto !important;
				color: @white-color;
			}
		}
	}

	.h-menu-dark .h-menu-show:hover {
		background-color: #3b76f5;
	}
</style>
